import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#00bcd4",
        secondary: "#009688",
        accent: "#cddc39",
        error: "#607d8b",
        warning: "#ff9800",
        info: "#3f51b5",
        success: "#4caf50"
      }
    }
  }
});
